import MainTitle from './MainTitle'
import TuiCalendar from './TuiCalendar'
import { useParams, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import useAuth from '../hooks/useAuth'
import useAxiosPrivate from '../hooks/useAxiosPrivate'

import UserNav from './UserNav'

function PractitionerBookingCalendar() {
  const axios = useAxiosPrivate()

  const [calendarType, setCalendarType] = useState('bookings')
  const [currentEvents, setCurrentEvents] = useState([])

  const { auth, setShowLoader } = useAuth()
  const path = useParams()
  const navigate = useNavigate()

  const goBack = () => {
    navigate(-1)
  }

  const loadCalendarEvents = async (from, to, cancelled = false) => {
    setShowLoader(true)
    try {

      if (!cancelled) {
        const response = await axios.get(
          `/users/${path.id}/sessions/${from}/${to}`
        )
        setCurrentEvents(response.data.result)
      } else {
        const response = await axios.get(
          `/users/${path.id}/sessions/cancelled/${from}/${to}`
        )
        setCurrentEvents(response.data.result)
      }
    } catch (error) {}
    // }
    setShowLoader(false)
  }

  return (
    <section>
      <MainTitle title="Practitioner Bookings" />

      <UserNav active="bookings" userId={path.id} />

      <TuiCalendar
        events={currentEvents}
        loadEvents={loadCalendarEvents}
        calendarType="bookings"
        userId={path.id}
      />
    </section>
  )
}

export default PractitionerBookingCalendar
